<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('agencies')">Agencies</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Name" />

          <text-input v-model="form.code" :error="errors.code" class="pr-6 pb-8 w-full lg:w-1/2" label="Code" />

          <text-input v-model="form.address" :error="errors.address" class="pr-6 pb-8 w-full lg:w-1/2" label="Address" />

          <select-input v-model="form.city" :error="errors.city" class="pr-6 pb-8 w-full lg:w-1/2" label="City">
            <option v-for="city in cities" :key="city.id" :value="city.id" >{{city.name}}</option>
          </select-input>

          <select-input v-model="form.operator" :error="errors.operator" class="pr-6 pb-8 w-full lg:w-1/2" label="Operator">
            <option v-for="operator in operators" :key="operator.id" :value="operator.id" >{{operator.name}}</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex justify-end items-center">
          <loading-button :loading="sending" class="btn-indigo" type="submit">Create Agency</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Layouts/AppLayout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo: { title: 'Create Agency' },
  layout: Layout,
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  props: {
    errors: Object,
    operators: Array,
    cities: Array,
  },
  remember: 'form',
  data() {
    return {
      sending: false,
      form: {
        name: null,
        code: null,
        address: null,
        city: null,
        operator: null,
      },
    }
  },
  methods: {
    submit() {
      const data = new FormData()
      data.append('name', this.form.name || '')
      data.append('code', this.form.code || '')
      data.append('address', this.form.address || '')
      data.append('city', this.form.city || '')
      data.append('operator', this.form.operator || '')

      this.$inertia.post(this.route('agencies.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
  },
}
</script>
